import Axios from "axios";
import { ApiBaseUrl, Customer } from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  GetAllCustomerInfoDetailResponse,
  GetAllCustomerInfoFilter,
  GetAllCustomerInfoRequest,
  GetAllCustomerInfoResponse,
} from "../models/customer.model";

export const GetAllCustomerInfo = async (
  data: GetAllCustomerInfoRequest
): Promise<ApiResultModel<GetAllCustomerInfoResponse[]>> => {
  return await Axios.post<ApiResultModel<GetAllCustomerInfoResponse[]>>(
    ApiBaseUrl + Customer + "/GetAllCustomerInfo",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetCustomerInfoDetail = (data: {
  customerId: number;
}): Promise<GetAllCustomerInfoDetailResponse> => {
  return Axios.get<ApiResultModel<GetAllCustomerInfoDetailResponse>>(
    ApiBaseUrl + Customer + "/GetCustomerInfoDetail/" + data.customerId
  ).then((result) => {
    return result.data.data;
  });
};

export const GetAllCustomerInfoExcel = async (
  data: GetAllCustomerInfoFilter
) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + Customer + "/GetAllCustomerInfoExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"لیست مشتری ها"}.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
